import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle, Phone, MapPin } from "lucide-react";

export const Footer = ({ settings }) => {
  const wa = settings?.whatsapp_number;
  const igHandle = (settings?.instagram || "")
    .trim()
    .replace(/^https?:\/\/(www\.)?instagram\.com\//i, "")
    .replace(/^@+/, "")
    .replace(/\/+$/, "");
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#0A0A0B] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <h3 className="font-heading text-3xl text-ink">{settings?.brand_name || "Trendy threads by Vee"}</h3>
          <p className="font-accent text-[10px] tracking-[0.35em] uppercase text-champagne mt-2">
            {settings?.tagline || "VeeVee's"}
          </p>
          <p className="text-ash text-sm leading-relaxed mt-6 max-w-xs">
            Threads woven with soul. Curated fashion for those who dress with intention.
          </p>
        </div>

        <div>
          <p className="font-accent text-xs tracking-[0.25em] uppercase text-ash mb-5">Explore</p>
          <ul className="space-y-3">
            <li><Link to="/" className="text-ink hover:text-champagne transition-colors">Home</Link></li>
            <li><Link to="/collections" className="text-ink hover:text-champagne transition-colors">Collections</Link></li>
            <li><Link to="/#about" className="text-ink hover:text-champagne transition-colors">About</Link></li>
          </ul>
        </div>

        <div>
          <p className="font-accent text-xs tracking-[0.25em] uppercase text-ash mb-5">Get in touch</p>
          <div className="space-y-4">
            {wa && (
              <a
                href={`https://wa.me/${wa}`}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp"
                className="flex items-center gap-3 text-ink hover:text-champagne transition-colors"
              >
                <MessageCircle size={18} strokeWidth={1.5} /> WhatsApp us to order
              </a>
            )}
            {settings?.phone && (
              <a href={`tel:${settings.phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="flex items-center gap-3 text-ink hover:text-champagne transition-colors">
                <Phone size={18} strokeWidth={1.5} /> {settings.phone}
              </a>
            )}
            {settings?.contact_email && (
              <a href={`mailto:${settings.contact_email}`} className="flex items-center gap-3 text-ink hover:text-champagne transition-colors">
                <Mail size={18} strokeWidth={1.5} /> {settings.contact_email}
              </a>
            )}
            {settings?.address && (
              <p data-testid="footer-address" className="flex items-start gap-3 text-ink">
                <MapPin size={18} strokeWidth={1.5} className="mt-0.5 shrink-0" /> {settings.address}
              </p>
            )}
            {igHandle && (
              <a
                href={`https://www.instagram.com/${igHandle}/`}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="flex items-center gap-3 text-ink hover:text-champagne transition-colors"
              >
                <Instagram size={18} strokeWidth={1.5} /> @{igHandle}
              </a>
            )}
          </div>
          {settings?.owner_name && (
            <p className="text-ash/60 text-xs tracking-wide mt-6" data-testid="footer-owner">
              Proprietor — {settings.owner_name}
            </p>
          )}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3">
        <p className="text-ash/60 text-xs tracking-wider">
          © {new Date().getFullYear()} {settings?.brand_name || "Trendy threads by Vee"}. All rights reserved.
        </p>
        <Link to="/admin/login" data-testid="admin-link" className="text-ash/40 text-xs tracking-wider hover:text-champagne transition-colors">
          Admin
        </Link>
      </div>
    </footer>
  );
};
